// extracted by mini-css-extract-plugin
export default {"addDecoratorButton":"DecoratorMatrix_addDecoratorButton__Mm3Q1","addDecorationButton":"DecoratorMatrix_addDecorationButton__FYexx"};